import React, { useState, useEffect } from "react";
import {
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
  Button,
  Modal,
} from "@material-ui/core";
import { rem } from "./utils/remConverter";
import { amountViewFormat } from "./utils/helper";
const inputStyle = {
  padding: `${rem(20)}`,
};

const formContainer = {
  paddingLeft: `${rem(20)}`,
  paddingRight: `${rem(20)}`,
  background: "#fff",
  width: `${rem(300)}`,
  height: "auto",
  margin: "auto",
  marginTop: `${rem(30)}`,
  paddingBottom: `${rem(20)}`,
  borderRadius: `${rem(20)}`,
};
const modalStyle = {
  position: "absolute",
  width: `${rem(300)}`,
  backgroundColor: "#fff",
  borderRadius: `${rem(20)}`,
  padding: `${rem(20)}`,
  top: `${rem(20)}`,
  outline: "none",
  overflowY: "scroll",
  // boxShadow: theme.shadows[5],
  // padding: theme.spacing(2, 4, 3),
};
const labelStyle = {
  fontSize: `${rem(15)}`,
  color: "#696974",
  padding: "0px 20px",
};
const dataStyle = {
  fontSize: `${rem(25)}`,
  color: "#3dd598",
  fontWeight: "bold",
  padding: "0px 20px",
  paddingBottom: `${rem(20)}`,
};
const buttonStyle = { marginLeft: `${rem(20)}`, backgroundColor: "#3dd598" };
function App() {
  const [salary, setSalary] = useState();
  const [salaryPercent, setSalaryPercent] = useState(20);
  const [year, setYear] = useState(5);
  const [carType, setCarType] = useState();
  const [rate, setRate] = useState();
  let loanMax = 0;
  const [isSubmitted, setSubmit] = useState(false);
  const [open, setOpen] = React.useState(false);
  useEffect(() => {
    if (carType === "firstHand") {
      setRate(7);
    } else if (carType === "secondHand") {
      setRate(14);
    }
  }, [carType]);
  const handleClick = () => {
    setSubmit(true);
    handleOpen();
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  function PV() {
    let pvRate = parseFloat(rate) / 100.0;
    let emiMax = (salary * salaryPercent) / 100;
    console.log(Math.pow(1 + pvRate / 12, year * 12) - 1);
    loanMax =
      emiMax /
      (((pvRate / 12) * Math.pow(1 + pvRate / 12, year * 12)) /
        (Math.pow(1 + pvRate / 12, year * 12) - 1));
    return (
      emiMax /
      (((pvRate / 12) * Math.pow(1 + pvRate / 12, year * 12)) /
        (Math.pow(1 + pvRate / 12, year * 12) - 1))
    );
  }
  const DisplayCars = () => {
    let carsArray = [];
    if (loanMax < 250000) {
      carsArray = [];
    } else if (loanMax < 500000) {
      carsArray = [
        "Maruti Suzuki S-Presso",
        "Maruti Suzuki Alto",
        "Maruti Suzuki Eeco",
        "Datsun redi-GO",
        "Renault Kwid",
      ];
    } else if (loanMax < 750000) {
      carsArray = [
        "Maruti Suzuki Swift",
        "Hyundai Grand i10 Nios",
        "Renault Triber",
        "Tata Tiago",
        "Maruti Suzuki Ignis",
      ];
    } else if (loanMax < 1200000) {
      carsArray = [
        "Honda Amaze",
        "Toyota Urban Cruiser",
        "Maruti Suzuki Ciaz",
        "Mahindra XUV300",
        "Nissan Magnite",
        "Hyundai i20",
        "Hyundai Venue",
        "Kia Sonet",
        "Skoda Rapid",
        "Ford Freestyle",
      ];
    } else if (loanMax < 1600000) {
      carsArray = [
        "Toyota Yaris",
        "Honda WRV",
        "Honda Amaze",
        "Ford EcoSport",
        "Renault Duster",
        "Mahindra Thar",
        "Tata Altroz",
      ];
    } else {
      carsArray = [
        "Tata Harrier",
        "MG Hector",
        "Tata Safari",
        "Kia Carnival",
        "Toyota Innova Crysta",
      ];
    }
    return (
      <>
        <p style={labelStyle}>Available Cars</p>
        {carsArray.map((car, idx) => (
          <p
            style={{
              color: "#3dd598",
              padding: "0px 20px",
              fontWeight: "bold",
            }}
          >
            {car}
          </p>
        ))}
      </>
    );
  };
  const body = (
    <div style={modalStyle}>
      <label style={labelStyle}>Down Payment</label>
      <div style={dataStyle}>
        {amountViewFormat((PV() * (1 / 0.8 - 1)).toFixed(2))}
      </div>
      <label style={labelStyle}>Loan Amount</label>
      <div style={dataStyle}>{amountViewFormat(PV().toFixed(2))}</div>
      <label style={labelStyle}>Vehicle Amount</label>
      <div style={dataStyle}>{amountViewFormat((PV() / 0.8).toFixed(2))}</div>
      {carType === "firstHand" ? <DisplayCars /> : null}
    </div>
  );
  return (
    <div
      style={{
        backgroundColor: "#f0f0f0",
        overflow: "hidden",
        height: "100vh",
        overflowY: "scroll",
      }}
    >
      <div style={formContainer} className="App">
        <div style={inputStyle}>
          <TextField
            id="outlined-basic"
            label="Salary Per Month"
            variant="outlined"
            type="number"
            value={salary}
            style={{ width: "100%" }}
            onChange={(e) => setSalary(e.target.value)}
          />
        </div>
        <div style={inputStyle}>
          <TextField
            id="outlined-basic"
            label="Percentage of Salary for EMI"
            variant="outlined"
            type="number"
            value={salaryPercent}
            style={{ width: "100%" }}
            onChange={(e) => setSalaryPercent(e.target.value)}
          />
        </div>
        <div style={inputStyle}>
          <TextField
            id="outlined-basic"
            label="EMI Max"
            variant="outlined"
            type="number"
            value={(salary * salaryPercent) / 100}
            style={{ width: "100%" }}
            disabled
          />
        </div>
        <div style={inputStyle}>
          <TextField
            id="outlined-basic"
            label="Number of Years of Loan"
            variant="outlined"
            type="number"
            value={year}
            style={{ width: "100%" }}
            onChange={(e) => setYear(e.target.value)}
          />
        </div>
        <div style={inputStyle}>
          <RadioGroup
            aria-label="carType"
            name="carType"
            value={carType}
            onChange={(e) => setCarType(e.target.value)}
          >
            <FormControlLabel
              value="firstHand"
              control={<Radio />}
              label="New Car"
            />
            <FormControlLabel
              value="secondHand"
              control={<Radio />}
              label="Used Car"
            />
          </RadioGroup>
        </div>
        <div style={inputStyle}>
          <TextField
            id="outlined-basic"
            label="Rate of Interest on The Loan"
            variant="outlined"
            type="number"
            value={rate}
            defaultValue={0}
            style={{ width: "100%" }}
            onChange={(e) => setRate(e.target.value)}
          />
        </div>
        <Button
          style={buttonStyle}
          variant="contained"
          color="primary"
          onClick={handleClick}
        >
          Submit
        </Button>
        <Modal
          open={open}
          onClose={handleClose}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {body}
        </Modal>
      </div>
    </div>
  );
}

export default App;
